<pc-error-popup
  [contentClass]="'dynamic-height'"
  [desktopImgPath]="desktopPopupImage"
  [imgAlt]="popupTexts().imgAlt || ''"
  [information]="errorMessage().information | translate"
  [isCloseIcon]="true"
  [mobileImgPath]="mobilePopupImage"
  [title]="errorMessage().title | translate"
  (closeErrorDialog)="onClose()"
  (closeWithSubmit)="onSubmit()"
>
  <main class="popup-content" section-content>
    <pc-separator [verticalHeight]="1"></pc-separator>
    <a class="body-medium phone-number" href="tel:{{ noSpaceServicePhoneNumber() }}"
      ><pc-icon [icon]="phoneIcon"></pc-icon>{{ servicePhoneNumber() }}</a
    >

    <pc-separator [verticalHeight]="1"></pc-separator>
    <section class="form-container">
      <pc-input
        data-sl="mask"
        [businessUnit]="BusinessUnit.AU"
        [formControl]="firstName"
        [isAutoFocus]="false"
        [isCapitalized]="true"
        [isSalesInput]="true"
        [placeholder]="formLabels().firstName"
        [validateOnBlur]="true"
      ></pc-input>
      <pc-input
        data-sl="mask"
        [businessUnit]="BusinessUnit.AU"
        [formControl]="lastName"
        [isAutoFocus]="false"
        [isCapitalized]="true"
        [isSalesInput]="true"
        [placeholder]="formLabels().lastName"
        [validateOnBlur]="true"
      ></pc-input>
      <div class="phone-container">
        <pc-autocomplete-dropdown
          [displayChevronIcon]="true"
          [displayIconWithCustomText]="true"
          [formControl]="phonePrefix"
          [label]="formLabels().countryCode"
          [lengthToOpenDropdown]="0"
          [noResultsText]="formLabels().noResults || ''"
          [oninputValue]="countryCodeValue()"
          [options]="countries()"
          [useIndex]="true"
          [useSingleItemFound]="true"
          (updateValueEvent)="onCountryCodeChange($event)"
        >
        </pc-autocomplete-dropdown>
        <pc-input
          data-sl="mask"
          [businessUnit]="BusinessUnit.AU"
          [formControl]="phoneNumber"
          [inputPlaceholder]="formLabels().phonePlaceholder"
          [isSalesInput]="true"
          [maxLimit]="phoneMaxLimit"
          [onlyNumbers]="true"
          [placeholder]="formLabels().phone"
          [validateOnBlur]="true"
        ></pc-input>
      </div>
    </section>

    <pc-gradient-btn
      [icon]="arrowIcon"
      [isDisabled]="disableButton || isLoading()"
      [isLoading]="isLoading()"
      [text]="popupTexts().button || (translations.continue | translate)"
      (btnClicked)="onSubmit()"
    ></pc-gradient-btn>
  </main>
</pc-error-popup>
